import { makeStyles } from '@material-ui/core';

export const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '15px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#757575',
    borderStyle: 'dashed',
    color: '#757575',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer'
};

export const activeStyle = {
    borderColor: '#007db8'
};

export const acceptStyle = {
    borderColor: '#007db8'
};

export const rejectStyle = {
    borderColor: '#B71C1C'
};


export const useFileUploadStyles = makeStyles(() => ({
    acceptedTypes: {
        color: "#757575"
    },
    uploadedFiles: {
        paddingTop: "5px"
    },
    rejectedFileError: {
        color: '#B71C1C'
    },
    actionButton: {
        cursor: 'pointer',
        color: '#007DB8'
    },
    progress: {
        width: '85%',
        padding: '8px',
        display: 'inline-block',
        marginLeft: '45px' 
    },
    cancel: {
        float: 'right',
        padding: '4px',
        color: '#3A3A3A',
        fontWeight: 'bold',
        marginTop: '20px'
    },
    uploadingFile: {
        paddingBottom: '5px',
        fontSize: '15px',
        display: 'flex'
    },
    rejectedFileStatus: {
        display: "flex",
        fontSize: "14px"
    },
    errorIcon: {
        color: '#B71C1C',
        marginRight: "3px"
    },
    errorBorder : {
        borderColor: 'var(--fire-red) !important' 
    },
    selectingFile : {
        color: '#007DB8'
    },
    box : {
        cursor: 'pointer',
        padding: '15px',
        textAlign: 'center',
        borderWidth: '2px',
        borderRadius: '2px',
        borderColor: 'rgb(117, 117, 117)',
        color: 'rgb(117, 117, 117)',
        borderStyle: 'dashed',
        outline: 'none',
        transition: 'border 0.24s ease-in-out 0s'
    }
}));
